import { Controller } from "@hotwired/stimulus"
import findScrollParent from "../concern/find_scroll_parent"
import TomSelect from "tom-select"

// Connects to data-controller="lazy-tag-select"
export default class extends Controller {
  static targets = ["select"]
  static values = {
    options: Array
  }

  initialize() {
    this.weakMap = new WeakMap()
  }

  connect() {
    this.#setObserver()
  }

  selectTargetConnected(target) {
    this.observer?.observe(target)
  }
  selectTargetDisconnected(target) {
    this.observer?.unobserve(target)
  }

  disconnect() {
    this.weakMap = new WeakMap()
    this.observer.disconnect()
  }

  #setObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.#setTomSelect(entry.target)
        }
      })
    }, {
      root: findScrollParent(this.element),
      rootMargin: '100% 0px'
    })

    this.selectTargets.forEach((elem) => {
      this.observer.observe(elem)
    })
  }


  #setTomSelect(elem) {
    if (this.weakMap.has(elem)) {
      return this.weakMap.get(elem)
    }

    const tomSelect = new TomSelect(elem, {
      plugins: ["checkbox_options", "no_active_items"],
      maxItems: null,
      valueField: "value",
      labelField: "text",
      searchField: ["text"],
      sortField: "text",
      persist: false,
      createOnBlur: false,
      create: false,
      openOnFocus: true,
      itemClass: "item pointer-events-none",
    })


    this.weakMap.set(elem, tomSelect)
    return tomSelect
  }
}
